module.exports = __webpack_public_path__ + "static/media/logo@2x.bab38a56.png";